module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "pxv"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _c('a', {
    attrs: {
      "id": "pxv"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("I went to the altar")]), _vm._v(" to marry my beloved in December 1990. Our courtship had begun four years earlier and culminated with a one-year engagement. Making a covenant with God in uniting with my husband was serious business. I wanted our marriage to be successful. Don’t we all? I look back now and consider the obstacles: we were young and immature in our faith. Although we had committed to going to church on Sundays with his parents, we still had so much to learn. Pastor James Cheshier made sure that his church family learned God’s design for marriage. As newlyweds, Jon and I sat under his teaching on Ephesians 5:22-33 and learned that it takes more than the love shared between two people to have a lasting marriage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pxv"
    }
  }), _c('a', {
    attrs: {
      "id": "pxvi"
    }
  }, [_vm._v("Shortly before our wedding day, my grandfather asked me if I wanted my marriage with Jon to work. He had me captive to his advice because I needed wisdom. He said that if I keep Jesus centered in my life, God will put everything else in its proper place. Knowing that my grandparents had been married for 49 years at that point, I reasoned that he spoke truth. I had already invited Jesus into my life, but now I invited Him into our marriage, and even though I did not know what it should look like or how it would be done, I decided to partner with God and build a household of faith. That was over 20 years ago. I have no regrets as I look back. My marriage is extremely blessed, and I believe that it will continue to see increase. God has taught us about this exciting Love Triangle, and I can say with confidence, “A chord of three strands is not quickly broken” (Ecclesiastes 4:12b).")])]), _c('a', {
    attrs: {
      "id": "pxvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b118d9e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 84
// module chunks = 0